import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PrintIcon from '@mui/icons-material/Print';
import styles from './index.module.css';

export const printInvoice = () => {
  if (typeof window === 'undefined') return;
  window.print();
};

const InvoicePrintActions = ({
  ready,
  isInternalUser,
  orderId,
  instanceUniqueId,
  invoiceId,
}) => {
  const isRenderMode =
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).has('render');

  if (!ready || !isInternalUser || isRenderMode) return null;

  const handlePrint = () => {
    printInvoice();
  };

  const handleEdit = () => {
    if (!orderId || !instanceUniqueId) return;

    const editUrl =
      `/instance/${instanceUniqueId}/sales/orders/${orderId}/invoice`;
    window.open(editUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      className={styles.printHidden}
      data-testid="invoice-print-actions"
      sx={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        zIndex: 2000,
        display: 'flex',
        gap: 1,
      }}
    >
      <Tooltip title="Edit invoice">
        <IconButton
          size="large"
          aria-label="Edit invoice"
          onClick={handleEdit}
          sx={{
            bgcolor: '#8B0000',
            color: '#fff',
            border: '1px solid #600000',
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              bgcolor: '#a00000',
            },
          }}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="Print / PDF">
        <IconButton
          size="large"
          aria-label="Print invoice"
          onClick={handlePrint}
          sx={{
            bgcolor: '#1976d2',
            color: '#fff',
            border: '1px solid #0f4fa1',
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              bgcolor: '#1e88e5',
            },
          }}
        >
          <PrintIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default InvoicePrintActions;
